const content = `
<p class="ql-align-center">
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
Before utilizing the AI authentication service, please carefully read and fully understand the instructions for TuSee AI Instant Authentication Agreement (hereinafter referred to as the "Rules"). Ensure that you use the AI authentication service with complete awareness and acceptance of these Rules. If you do not agree with or understand these Rules, please refrain from using the AI authentication services. Continuing to use the AI Identification Service implies recognition and agreement with all contents of these Rules.
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
1. TuSee's AI authentication service extracts feature points from the pictures you upload and makes judgments based on these features.
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
2. Prior to uploading authentication pictures, carefully review and upload them following the requirements outlined in the "Instructions"
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
3. Understand that remote authentication has inherent limitations such as photo shooting angle, lighting, clarity, and other influencing factors. As a result, authentication results may not consistently align each time. This differs from offline sensory authentication through physical touch inspection and thus cannot replace physical authentication.
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
4. We strive to provide corresponding services based on current technologies. AI authentication results are for reference purposes only.
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
5. You are responsible for any deviations in authentication results due to improper operation (including but not limited to: failure to follow example picture requirements, selecting the wrong brand for authentication, or maliciously manipulating pictures) when prompted for action.
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
6. These rules are formulated and publicized by the TuSee. TuSee retains the right to adjust and modify these rules, implementing them after notifying users. TuSee has the final authority to interpret the AI authentication technology of this platform. For inquiries regarding these rules, please contact contact@TuSeeai.com
</p>
<p class="ql-align-justify">
&nbsp;
</p>
<p class="ql-align-justify">
&nbsp;
</p>

<p class="ql-align-justify">
Due to variations in angles, lighting, etc., identical picture collections may yield different results. Please reshoot following the example provided.
</p>
<p>
<br>
</p>
`
export default {
  content,
  title: 'TuSee AI Instant Authentication Agreement' 
}
